import React, { createContext, useContext, useState } from 'react';

const AppLoadingContext = createContext({
    isAppLoaded: false,
    setAppLoaded: () => { }
});

export const useAppLoading = () => useContext(AppLoadingContext);

export const AppLoadingProvider = ({ children }) => {
    const [isAppLoaded, setAppLoaded] = useState(false);

    return (
        <AppLoadingContext.Provider value={{ isAppLoaded, setAppLoaded }}>
            {children}
        </AppLoadingContext.Provider>
    );
};
